export const subscribeOrderbookFields = [
  'instrument_id',
  {
    buy: ['quantity', 'price'],
  },
  {
    sell: ['quantity', 'price'],
  },
];

export const subscribeInstrumentPriceFields = [
  'instrument_id',
  'price_24h_change',
  'high',
  'low',
  'ts',
  'close',
  'open',
];

// instruments
export const priceFields = ['instrument_id', 'ask', 'bid', 'price_24h_change', 'ts_iso'];

export const priceBarFields = ['instrument_id', 'high', 'low', 'ts', 'close', 'open'];

export const getInstrumentsFields = [
  'name',
  'instrument_id',
  'base_currency_id',
  'quote_currency_id',
  'price_decimals',
  'min_quantity',
  'max_quantity',
  'min_quote_quantity',
  'max_quote_quantity',
  {
    quote_currency: ['precision'],
  },
  {
    base_currency: ['precision'],
  },
  {
    price: priceFields,
  },
];

// prices
export const instrumentsPricesFields = ['instrument_id', { price: ['ask', 'bid', 'price_24h_change', 'ts_iso'] }];

// currencies
export const getCurrenciesField = ['precision', 'type', 'currency_id'];

// chart
export const instrumentPriceBarsFields = [
  'instrument_id',
  'open',
  'close',
  'high',
  'low',
  'ts',
  'volume_from',
  'volume_to',
  'price_24h_change',
];

// order
export const getOrdersFields = [
  'id',
  'user_id',
  'side',
  'instrument_id',
  'type',
  'price',
  'quantity',
  'user_address',
  'escrow_address',
  'escrow_id',
  'deposit_amount',
  'status',
  'error_message',
  'state',
  'created_at',
  'updated_at',
];

export const contractsAndTokensListFields = [
  {
    contract: ['escrow', 'master'],
    tokens: ['name', 'address', 'decimals'],
  },
  'gas_deposit',
  'trading_fee',
  'slippage',
];
